import { GlassCard, GlassCardContent, GlassCardDescription, GlassCardHeader, GlassCardTitle } from "@/components/ui/glass-card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MonitorSmartphone } from "lucide-react";
import { useStaleDeviceThreshold, STALE_THRESHOLD_OPTIONS, type StaleThresholdDays } from "@/hooks/useStaleDeviceThreshold";

export function DeviceMonitoringSection() {
  const { days: staleThresholdDays, setDays: setStaleThresholdDays } = useStaleDeviceThreshold();
  return (
    <GlassCard variant="default" hover={false}>
      <GlassCardHeader>
        <GlassCardTitle className="flex items-center gap-2">
          <MonitorSmartphone className="h-5 w-5" />
          Device Monitoring
        </GlassCardTitle>
        <GlassCardDescription>
          Configure how the fleet inventory surfaces inactive devices
        </GlassCardDescription>
      </GlassCardHeader>
      <GlassCardContent className="space-y-4">
        <div className="space-y-2 max-w-sm">
          <Label htmlFor="stale-threshold">Stale device threshold</Label>
          <Select
            value={String(staleThresholdDays)}
            onValueChange={(v) => setStaleThresholdDays(Number(v) as StaleThresholdDays)}
          >
            <SelectTrigger id="stale-threshold">
              <SelectValue placeholder="Select threshold" />
            </SelectTrigger>
            <SelectContent>
              {STALE_THRESHOLD_OPTIONS.map((d) => (
                <SelectItem key={d} value={String(d)}>{d} days</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-sm text-muted-foreground">
            Devices that haven't checked in within this window are flagged on the All Devices card.
          </p>
        </div>
      </GlassCardContent>
    </GlassCard>
  );
}
